import React, { useEffect, useState } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useTranslation } from "../../langs/useTranslation";
import { getAllTagsAPI } from "../../apis/getAllTagsAPI";
import { useGroupDeviceDispatch, useGroupDeviceState } from "./Provider";
import Collapser from "../../components/Collapser";
import { IconFilter, IconTag } from "../../components/Icon";
import { useGlobalState } from "@/GlobalProvider";

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: theme.spacing(1)
  },
  title: {
    flex: 1,
    padding: "3px 2px",
    fontWeight: "bold"
  },
  title2: {
    cursor: "pointer"
  },
  tagItem: {
    display: "flex",
    minWidth: 0,
    padding: "6px 12px",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, .08)"
    }
  },
  tagName: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  actived: {
    backgroundColor: `${theme.palette.primary.opacity} !important`,
    color: theme.palette.primary.main
  }
}));

const DeviceTags = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [tags, setTags] = useState([]);
  const { currentCompanyId } = useGlobalState();
  const { setCurrentTag, setFilterByMode } = useGroupDeviceDispatch();
  const { loadingGroup, currentTag, filterBy, filterByMode, reloadTreeFlag } =
    useGroupDeviceState();

  const getTags = async () => {
    setTags([]);
    const data = await getAllTagsAPI(true);
    if (data?.tags?.length > 0) {
      setTags(data.tags);
    }
  };

  const handleSelect = tag => {
    setCurrentTag(tag);
  };

  useEffect(() => {
    getTags();
  }, [currentCompanyId, reloadTreeFlag]);

  if (loadingGroup) {
    return null;
  }

  return (
    <>
      <Collapser
        title={
          <Typography variant="subtitle1" className={classes.title}>
            <IconTag size={16} color="primary" style={{ marginRight: 5 }} />
            {t({ defaultMessage: "标签" })}
          </Typography>
        }
      >
        <div className={classes.root}>
          {tags.map(tag => {
            return (
              <Typography
                key={tag.id}
                variant="body2"
                className={clsx(
                  classes.tagItem,
                  currentTag && currentTag.id === tag.id && classes.actived
                )}
                onClick={() => handleSelect(tag)}
              >
                <span className={classes.tagName}>{tag.name}</span>
                <span>({tag.devices_count || 0})</span>
              </Typography>
            );
          })}
        </div>
      </Collapser>
      {filterBy && (
        <Collapser
          title={
            <Typography
              variant="subtitle1"
              className={clsx(
                classes.title,
                classes.title2,
                filterByMode && classes.actived
              )}
              onClick={() => setFilterByMode(true)}
            >
              <IconFilter
                size={16}
                color="primary"
                style={{ marginRight: 5 }}
              />
              {t({ defaultMessage: "Filter by" })}
            </Typography>
          }
        />
      )}
    </>
  );
};

export default DeviceTags;
